
  // Elements
  const headerSection = document.getElementById('headerSection');
  const heading = document.getElementById('heading');
  const transitionHeading = document.getElementById('transitionHeading');
  const searchWrapper = document.getElementById('searchWrapper');
  const searchContainer = document.getElementById('searchContainer');
  const searchBtn = document.getElementById('searchBtn');
  const storeInput = document.getElementById('storeInput');
  const previewCanvas = document.getElementById('previewCanvas');
  const actionButtonsContainer = document.getElementById('actionButtonsContainer');
  const iframeError = document.getElementById('iframeError');
  const previewIframe = document.getElementById('previewIframe');
  const iframeErrorText = document.getElementById('iframeErrorText');
  const loadingState = document.getElementById('loadingState');
const closeBtn = document.getElementById('closeBtn');

  let currentUrl = '';
  let isPreviewActive = false;



  // Initial animations
  gsap.to(heading, {
    opacity: 1,
    y: 0,
    duration: 1.2,
    ease: 'power3.out',
    delay: 0.2,
  });

  gsap.to(searchWrapper, {
    opacity: 1,
    duration: 1.2,
    ease: 'power3.out',
    delay: 0.4,
  });

  // Create matchMedia ONCE (outside function)
const mm = gsap.matchMedia();

function showPreview() {
  const url = storeInput.value.trim();

  if (!url) {
    alert('Please enter a URL');
    return;
  }

  // Reload iframe only
  if (isPreviewActive) {
    currentUrl = url;
    loadIframe(url);
    return;
  }

  isPreviewActive = true;
  currentUrl = url;

  // Responsive heading animation
  mm.add(
    {
      desktop: "(min-width: 769px)",
      mobile: "(max-width: 768px)",
    },
    (context) => {
      const { desktop } = context.conditions;

      const fontSize = desktop ? "32px" : "22px";

      gsap.set([heading, transitionHeading], { fontSize });

      const tl = gsap.timeline();

      searchWrapper.classList.add("expanded");

      tl.to([heading, transitionHeading], {
        fontSize,
        marginBottom: "10px",
        duration: 0.6,
        ease: "power2.out",
        force3D: true,
      }, 0)

        .to(searchWrapper, {
          duration: 0.8,
          ease: "power3.inOut",
        }, 0)

        .add(() => {
          headerSection.classList.add("moved-to-top");
          searchContainer.classList.add("connected");
        }, 0)

        .add(() => {
          actionButtonsContainer.classList.add("visible", "movedtotop");
        }, 0.3)

        .to(actionButtonsContainer, {
          opacity: 1,
          x: 0,
          duration: 0.6,
          ease: "back.out(1.7)",
        }, 0.4)

        .fromTo(
          [closeBtn],
          { opacity: 0, x: 30 },
          {
            opacity: 1,
            x: 0,
            duration: 0.5,
            stagger: 0.1,
            ease: "power2.out",
          },
          0.5
        )

        .add(() => previewCanvas.classList.add("active"), 0.3)

        .fromTo(
          previewCanvas,
          { opacity: 0 },
          {
            opacity: 1,
            duration: 0.8,
            ease: "power3.out",
          },
          0.4
        );
    }
  );

  loadIframe(url);
}


  function hidePreview() {
    if (!isPreviewActive) return;

    const tl = gsap.timeline();

    // 1. Hide action buttons with stagger (reverse order)
    tl.to(
      [ closeBtn],
      {
        opacity: 0,
        x: 30,
        duration: 0.3,
        stagger: 0.05,
        ease: 'power2.in',
      },
      0
    )
      .to(
        actionButtonsContainer,
        {
          opacity: 0,
          x: 50,
          duration: 0.4,
          ease: 'power2.in',
          onComplete: () => {
            actionButtonsContainer.classList.remove('visible');
          },
        },
        0.2
      )

      // 2. Hide preview canvas
      .to(
        previewCanvas,
        {
          opacity: 0,
          duration: 0.6,
          ease: 'power3.in',
          onComplete: () => {
            previewCanvas.classList.remove('active');
            previewIframe.src = '';
            previewIframe.classList.remove('loaded');
            loadingState.style.display = 'flex';
          },
        },
        0
      )

      // 3. Remove connected state and shrink search wrapper
      .add(() => {
        searchContainer.classList.remove('connected');
        searchWrapper.classList.remove('expanded');
      }, 0.2)

      // 4. Move header back to center
      .to(
        heading,
        {
          fontSize: '35px',
          marginBottom: '40px',
          duration: 0.6,
          ease: 'power3.inOut',
        },
        0.3
      )

      .to(
        transitionHeading,
        {
          fontSize: '35px',
          marginBottom: '40px',
          duration: 0.6,
          ease: 'power3.inOut',
        },
        0.3
      )

      .add(() => {
        headerSection.classList.remove('moved-to-top');
        actionButtonsContainer.classList.remove('movedtotop');
      }, 0.3)

      .to(
        headerSection,
        {
          onComplete: () => {
            isPreviewActive = false;
          },
        },
        0.3
      );
  }


function showIframeError(message) {
  loadingState.style.display = 'none';
  iframeError.style.display = 'flex';
  previewIframe.style.display = 'none';

  if (message) {
    iframeErrorText.textContent = message;
  }
}

function hideIframeError() {
  iframeError.style.display = 'none';
  previewIframe.style.display = 'block';
}

async function loadIframe(url) {
  loadingState.style.display = 'flex';
  hideIframeError();

  if (!url.startsWith('http://') && !url.startsWith('https://')) {
    url = 'https://' + url;
  }

  const encoded = encodeURIComponent(url);
  // const scriptBase =
  //   'https://cdn.shopify.com/s/files/1/0963/4611/2365/files/feedback.js?v=1766151614';
    // ✅ Read script URL from Shopify customizer
  const configEl = document.getElementById('playground-config');
  const scriptBase = configEl?.dataset.scriptUrl;

  if (!scriptBase) {
    console.error('Feedback script URL not provided');
    showIframeError();
    return;
  }
  const encodedScript = encodeURIComponent(scriptBase);

  const proxyUrl = `https://proxy.marmeto.org/proxy/v1/proxy?url=${encoded}&scriptUrl=${encodedScript}`;

  try {
    //Check HTTP status code
    const response = await fetch(proxyUrl, { method: 'GET' });

    // Any status except 200
    if (response.status !== 200) {
      showIframeError();
      return;
    }

    // Status 200 → load website
    previewIframe.src = proxyUrl;

    previewIframe.onload = () => {
      loadingState.style.display = 'none';
    };
  } catch (error) {
    showIframeError();
  }
}
	
  searchBtn.addEventListener('click', showPreview);

  storeInput.addEventListener('keypress', (e) => {
    if (e.key === 'Enter') {
      showPreview();
  }
  });

  // Watch for URL input changes
  storeInput.addEventListener('input', (e) => {
    const url = e.target.value.trim();

    // If URL is cleared and preview is active, hide it
    if (!url && isPreviewActive) {
      hidePreview();
    }
  });

  closeBtn.addEventListener('click', hidePreview);

  previewIframe.addEventListener('load', () => {
    if (previewIframe.src) {
      loadingState.style.display = 'none';
      previewIframe.classList.add('loaded');
    }
  });






